import { Tabs } from "antd";
import NarinLayout from "components/NarinLayout";
import { useNavigate, useParams } from "react-router-dom";
import UserProfileForm from "./components/UserProfileForm";
import OrderHistoryForm from "./components/OrderHistoryForm";
import FavoritesForm from "./components/FavoriteForm";
import useUserStore from "stores/user";
import { useLayoutEffect } from "react";
const menuSetting = [
  {
    label: "ข้อมูลส่วนตัว",
    key: "user-profile",
    children: (
      <div className="pt-1 p-4 md:p-4">
        <UserProfileForm />
      </div>
    ),
  },
  {
    label: "รายการสั่งซื้อ",
    key: "order-history",
    children: (
      <div className="p-4 md:p-4">
        <OrderHistoryForm />
      </div>
    ),
  },
  {
    label: "รายการโปรด",
    key: "favorite",
    children: (
      <div className="p-4 md:p-4">
        <FavoritesForm />
      </div>
    ),
  },
  // {
  //   label: "แนะนำเพื่อน",
  //   key: "referral",
  //   children: (
  //     <div className="p-12">
  //       <ReferralForm />
  //     </div>
  //   ),
  // },
];
const SettingPage = () => {
  const { tab } = useParams();
  const { user } = useUserStore();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!user) {
      navigate("/");
    }
  });
  return (
    <NarinLayout>
      <div className="py-8 px-4">
        <Tabs
          activeKey={tab}
          key={tab}
          onTabClick={(param) => navigate(`/setting/${param}`)}
          className="setting-tab bg-white"
          size="small"
          type="card"
          items={menuSetting}
          tabBarGutter={12}
        />
      </div>
    </NarinLayout>
  );
};
export default SettingPage;
